import { Col, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import useMazakaForm from "hooks/useMazakaForm";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { resetPassword } from "apps/Account/Services";
import { MazakaPassword } from "apps/Common/MazakaPassword";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  let code = decodeURIComponent(searchParams.get("code") || "");
  code = code.replace(/\ /g, "+");
  code = decodeURIComponent(code);
  const navigate = useNavigate();
  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    formValues["userId"] = userId;
    formValues["code"] = code;

    try {
      const response = await resetPassword(formValues);
      mazakaForm.setSuccess(1000, () => "Şifreniz Başarıyla Değiştirildi");
      openNotificationWithIcon("default",response.message)
      navigate("/");
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      openNotificationWithIcon("default", error?.message);

      console.log("Şifre yenileme sırasında bir hata oluştu", error);
    }
  };

  const { Text } = Typography;

  return (
    <>
      <Col span={16} offset={4}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="!px-16">
            <Col span={24} className="!flex justify-center">
              <Text className="!text-2xl !font-bold">Şifrenizi Yenileyin</Text>
            </Col>
            <MazakaPassword
              xs={24}
              name={"newPassword"}
              label={"Yeni Şifre"}
              className="!m-0"
              inputClassName="!bg-[#f7f7f7] !p-2"
              placeholder="Yeni şifrenizi girin"
              rules={[{required:true,message:""}]}
            />

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Şifreyi Değiştir
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ResetPassword;
